function resizeBase64Image(
  base64Image: string,
  options?: {
    type?: string;
    maxWidth?: number;
    maxHeight?: number;
    quality?: number;
    maxSize?: number;
  }
): Promise<string> {
  const {
    type = 'image/jpeg',
    maxWidth = 512,
    maxHeight = 512,
    quality = 70,
    maxSize,
  } = options || {};

  return new Promise<string>((resolve, reject) => {
    const img = new Image();
    img.onerror = reject;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const [newWidth, newHeight] = calculateDimensions(
        img.width,
        img.height,
        maxWidth,
        maxHeight
      );

      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      let currentQuality = quality;
      const compressImage = () => {
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Failed to create blob'));
              return;
            }

            if (maxSize && blob.size > maxSize && currentQuality > 10) {
              currentQuality -= 10;
              compressImage();
              return;
            }

            blobToBase64(blob)
              .then((compressedBase64) => {
                if (compressedBase64.length >= base64Image.length) {
                  resolve(base64Image);
                } else {
                  resolve(compressedBase64);
                }
              })
              .catch(reject);
          },
          type,
          currentQuality / 100
        );
      };

      compressImage();
    };
    img.src = base64Image;
  });
}

function calculateDimensions(
  width: number,
  height: number,
  maxWidth: number,
  maxHeight: number
): [number, number] {
  const aspectRatio = width / height;

  if (width > maxWidth) {
    width = maxWidth;
    height = width / aspectRatio;
  }

  if (height > maxHeight) {
    height = maxHeight;
    width = height * aspectRatio;
  }

  return [Math.floor(width), Math.floor(height)];
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export default resizeBase64Image;
